<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="addStudentDialog.title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    @close="closeDialog"
  >
    <div class="form">
      <el-form
        ref="form"
        :model="form"
        :rules="form_rules"
        :label-width="dialog.formLabelWidth"
        style="margin: 10px; width: auto"
      >
        <el-form-item required prop="stdName" label="学员姓名:">
          <el-input type="text" v-model="form.stdName"></el-input>
        </el-form-item>

        <el-form-item prop="stdNickname" label="学员小名">
          <el-input type="text" v-model="form.stdNickname"></el-input>
        </el-form-item>

        <!-- <el-form-item prop="stdSex" label="学员性别:">
          <el-select v-model="form.stdSex" placeholder="请选择学员性别">
            <el-option
              v-for="item in stdSex"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>-->

        <el-form-item required prop="stdAge" label="学员年龄" style="display:none">
          <el-input
            :disabled="changeDisabled"
            type="text"
            v-model="form.stdAge"
          ></el-input>
        </el-form-item>
        <el-form-item required prop="stdAge" label="学员年龄">
          <el-input
            :disabled="changeDisabled"
            type="text"
            v-model="ageShow"
          ></el-input>
        </el-form-item>
        <!--需要导入日期插件-->
        <el-form-item required prop="stdBirthday" label="学员生日">
          <el-date-picker
            value-format="yyyy-MM-dd"
            :disabled="false"
            v-model="form.stdBirthday"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item required prop="stdArea" label="地区">
          <el-input type="text" v-model="form.stdArea"></el-input>
        </el-form-item>
        <el-form-item required prop="stdBike" label="坐骑">
          <el-input type="text" v-model="form.stdBike"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="stdTelephoneNumber" label="家长联系电话">
          <el-input type="text" v-model="form.stdTelephoneNumber"></el-input>
        </el-form-item> -->

        <!-- <el-form-item prop="stdParentName" label="家长:">
          <el-select :disabled="changeDisabled" v-model="form.stdParentName" placeholder="家长姓名">
            <el-option
              v-for="item in this.memberLists.memberList"
              :key="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item> -->

        <!-- <el-form-item prop="stdMemberType" label="会员类型:">
          <el-select v-model="form.stdMemberType" placeholder="会员类型">
            <el-option
              v-for="item in memberType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item required prop="stdStatus" label="学员状态">
          <el-select v-model="form.stdStatus" placeholder="学员状态">
            <el-option
              v-for="item in statusType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="text_right">
          <el-button @click="isVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { addStudent, updateStudent } from "@/api/student";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  name: "addFundDialogs",
  data() {
    let validateData = (rule, value, callback) => {
      if (value === "") {
        let text;
        if (rule.field == "telephoneNumber") {
          text = "手机号";
        } else if (rule.field == "name") {
          text = "姓名";
        }
        callback(new Error(text + "不能为空~"));
      } else {
        let numReg = /^1[3456789]\d{9}$/;
        if (!numReg.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      }
    };
    return {
      ageShow: 0,
      isVisible: this.isShow,
      changeDisabled: false,
      form: {
        id: "",
        stdParentName: "",
        stdTelephoneNumber: "",
        stdName: "",
        stdMemberType: "",
        stdNickname: "",
        stdIsPassExam: "",
        stdIsPassExam1: "",
        stdIsPassHighExam: "",
        stdIsPassTeamExam: "",
        stdAge: "",
        stdSex: "",
        stdBirthday: "",
        stdArea: "",
        stdBike: "",
        stdStatus: "",
      },
      stdSex: [
        { label: "男", value: "0" },
        { label: "女", value: "1" },
      ],
      statusType: [
        { label: "未审核", value: "0" },
        { label: "审核通过", value: "1" },
        { label: "审核失败", value: "2" },
      ],
      memberType: [
        { label: "临时会员", value: "0" },
        { label: "正式会员", value: "1" },
      ],
      passExamType: [
        { label: "通过", value: "false" },
        { label: "未通过", value: "true" },
      ],
      form_rules: {
        stdName: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        stdParentName: [
          { required: true, message: "家长不能为空", trigger: "blur" },
        ],
        stdStatus: [
          { required: true, message: "请选择学员状态", trigger: "blur" },
        ],
        stdIsPassExam: [
          { required: true, message: "请选择是否通过考核", trigger: "blur" },
        ],
      },
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
    };
  },
  props: {
    isShow: Boolean,
    dialogRow: Object,
    memberLists: Object,
  },
  computed: {
    ...mapGetters(["addStudentDialog", "memberList"]),
  },
  created() {},
  mounted() {
    console.log(this.memberLists.memberList);
    if (this.addStudentDialog.type === "edit") {
      this.changeDisabled = true;
      this.form = this.dialogRow;
      console.log(this.form);
      console.log(this.form.id);
      this.form.id = this.dialogRow.stdId;
      this.form.stdMemberType = this.dialogRow.stdMemberType.toString();
      this.form.stdStatus = this.dialogRow.stdStatus.toString();
      // this.form.stdIsPassExam = this.dialogRow.stdIsPassExam.toString();
      // this.form.stdIsPassExam1 = this.dialogRow.stdIsPassExam1.toString();
      // this.form.stdIsPassHighExam = this.dialogRow.stdIsPassHighExam.toString();
      // this.form.stdIsPassTeamExam = this.dialogRow.stdIsPassTeamExam.toString();
      //start 计算年龄
      console.log(this.dialogRow,56456456456);
      var date = new Date();
      var startDate = new Date(this.dialogRow.stdBirthday);
      var newDate = date.getTime() - startDate.getTime();
      this.ageShow = Math.floor(newDate / 1000 / 60 / 60 / 24 / 365);
      //end 计算年龄
    } else {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    //表单提交
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let formData = this[form];
          const para = Object.assign({}, formData);
          console.log(para);
          // edit
          if (this.addStudentDialog.type === "edit") {
            updateStudent(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content: "修改(" + this.form.stdName + ")学员操作",
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.isVisible = false;
                this.$emit("getStudentList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          } else {
            // add
            addStudent(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content: "新增(" + this.form.stdName + ")学员操作",
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.$refs["form"].resetFields();
                this.isVisible = false;
                this.$emit("getStudentList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
